/* =============================================
   ELOPOXY - main.js
   ============================================= */

(function () {
  'use strict';

  // ======== Effet liquide sur les boutons ========
  // On injecte un SVG inline dans chaque .btn-primary / .btn-outline
  // (on évite les variantes -sm utilisées pour les boutons cookie).
  const liquidSVG = (color, waveColor) => `
    <svg class="btn-liquid" viewBox="0 0 240 80" preserveAspectRatio="none" aria-hidden="true">
      <g class="btn-liquid-tank">
        <g class="btn-liquid-wave-slide">
          <path fill="${waveColor}"
                d="M0,10
                   C20,2 40,18 60,10
                   C80,2 100,18 120,10
                   C140,2 160,18 180,10
                   C200,2 220,18 240,10
                   C260,2 280,18 300,10
                   C320,2 340,18 360,10
                   C380,2 400,18 420,10
                   C440,2 460,18 480,10
                   L480,80 L0,80 Z"/>
        </g>
        <rect x="-10" y="14" width="500" height="200" fill="${color}"/>
      </g>
    </svg>
  `;

  document.querySelectorAll('.btn-primary, .btn-outline').forEach((btn) => {
    // ne pas réinjecter
    if (btn.querySelector('.btn-liquid')) return;
    // Ne pas appliquer aux variantes cookie
    if (btn.classList.contains('btn-primary-sm') || btn.classList.contains('btn-ghost-sm')) return;

    const isPrimary = btn.classList.contains('btn-primary');
    // Primary : liquide rose foncé sur fond rose clair
    // Outline : liquide rose vif sur fond transparent
    const color     = isPrimary ? '#8e0e44' : '#e91e63';
    const waveColor = isPrimary ? '#ad1654' : '#f06292';

    // Wrapper le texte brut dans un span pour qu'il soit AU-DESSUS du SVG (z-index)
    // (sans ce wrap, les nœuds texte ne peuvent pas avoir de z-index et passent
    // derrière le SVG en position:absolute)
    Array.from(btn.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        const span = document.createElement('span');
        span.className = 'btn-label';
        span.textContent = node.textContent;
        btn.replaceChild(span, node);
      }
    });

    btn.insertAdjacentHTML('afterbegin', liquidSVG(color, waveColor));
  });


  // ======== Loader liquide ========
  // Durée totale de l'animation : ~2.1s
  const loader = document.getElementById('loader');
  if (loader) {
    const MIN_DURATION = 1800;     // dès que le lotus est rempli
    const MAX_DURATION = 4000;     // Filet de sécurité
    const startTime = performance.now();

    const hideLoader = () => {
      const elapsed = performance.now() - startTime;
      const remaining = Math.max(0, MIN_DURATION - elapsed);
      setTimeout(() => {
        document.body.classList.add('loaded');
        setTimeout(() => loader && loader.remove(), 600);
      }, remaining);
    };

    if (document.readyState === 'complete') {
      hideLoader();
    } else {
      window.addEventListener('load', hideLoader, { once: true });
      setTimeout(hideLoader, MAX_DURATION);
    }
  }

  // ======== Header scroll effect ========
  const header = document.getElementById('header');
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 20) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // ======== Mobile menu (burger) ========
  const burger = document.getElementById('burger');
  const nav = document.querySelector('.main-nav');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      nav.classList.toggle('open');
      burger.classList.toggle('active');
    });
  }

  // ======== Cookie banner ========
  const banner = document.getElementById('cookieBanner');
  const acceptBtn = document.getElementById('cookieAccept');
  const refuseBtn = document.getElementById('cookieRefuse');
  const COOKIE_KEY = 'elopoxy_cookie_consent';

  if (banner) {
    const consent = (function () {
      try { return localStorage.getItem(COOKIE_KEY); } catch (e) { return null; }
    })();

    if (!consent) {
      setTimeout(() => banner.removeAttribute('hidden'), 1200);
    }

    const setConsent = (value) => {
      try { localStorage.setItem(COOKIE_KEY, value); } catch (e) {}
      banner.setAttribute('hidden', '');
    };

    if (acceptBtn) acceptBtn.addEventListener('click', () => setConsent('accepted'));
    if (refuseBtn) refuseBtn.addEventListener('click', () => setConsent('refused'));
  }

  // ======== Smooth product card hover (touch fallback) ========
  document.querySelectorAll('.product').forEach((card) => {
    card.addEventListener('click', (e) => {
      // Don't trigger if click was on the add-to-cart button
      if (e.target.closest('.product-add')) return;
      // For now this is just a placeholder - in real version, navigate to product page
      // window.location.href = '/produit/' + card.dataset.slug;
    });
  });

  // ======== Add to cart with mini animation ========
  const cartBadge = document.querySelector('.cart-badge');
  document.querySelectorAll('.product-add').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      btn.style.transform = 'scale(1.3)';
      setTimeout(() => { btn.style.transform = ''; }, 200);
      if (cartBadge) {
        const n = parseInt(cartBadge.textContent || '0', 10) + 1;
        cartBadge.textContent = String(n);
        cartBadge.style.transform = 'scale(1.4)';
        setTimeout(() => { cartBadge.style.transform = ''; }, 250);
      }
    });
  });


  // ======== Curseur custom : lotus + cercle qui suit en lag ========
  // Désactivé sur mobile/tactile (pas de souris)
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (!isTouchDevice && window.matchMedia('(pointer: fine)').matches) {
    // Création des deux éléments
    const dot = document.createElement('div');
    dot.className = 'cursor-dot';
    dot.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <!-- Lotus stylisé : 5 pétales superposés -->
        <g transform="translate(12, 13)">
          <ellipse cx="-7" cy="0" rx="3" ry="6" fill="#e91e63" opacity="0.85" transform="rotate(-50)"/>
          <ellipse cx="7" cy="0" rx="3" ry="6" fill="#e91e63" opacity="0.85" transform="rotate(50)"/>
          <ellipse cx="-4" cy="-3" rx="3" ry="7" fill="#f06292" opacity="0.9" transform="rotate(-20)"/>
          <ellipse cx="4" cy="-3" rx="3" ry="7" fill="#f06292" opacity="0.9" transform="rotate(20)"/>
          <ellipse cx="0" cy="-4" rx="2.5" ry="7" fill="#f8bbd0"/>
        </g>
      </svg>
    `;

    const ring = document.createElement('div');
    ring.className = 'cursor-ring';

    document.body.appendChild(dot);
    document.body.appendChild(ring);

    // Position cible (souris) et position courante (cercle)
    const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ringPos = { x: mouse.x, y: mouse.y };

    // Vitesse de poursuite du cercle (0 = jamais, 1 = instantané)
    const easing = 0.15;

    document.addEventListener('mousemove', (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      // Le lotus suit instantanément
      dot.style.transform = `translate(${mouse.x}px, ${mouse.y}px) translate(-50%, -50%)`;
    });

    // Boucle d'animation pour le cercle (lerp)
    function animateRing() {
      ringPos.x += (mouse.x - ringPos.x) * easing;
      ringPos.y += (mouse.y - ringPos.y) * easing;
      ring.style.transform = `translate(${ringPos.x}px, ${ringPos.y}px) translate(-50%, -50%)`;
      requestAnimationFrame(animateRing);
    }
    animateRing();

    // États interactifs : grossir le cercle au survol des éléments cliquables
    const hoverables = 'a, button, .product, .product-add, [role="button"], input, textarea, select';
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest(hoverables)) {
        ring.classList.add('cursor-ring--hover');
        dot.classList.add('cursor-dot--hover');
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest(hoverables)) {
        ring.classList.remove('cursor-ring--hover');
        dot.classList.remove('cursor-dot--hover');
      }
    });

    // Cacher le curseur quand la souris quitte la fenêtre
    document.addEventListener('mouseleave', () => {
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', () => {
      dot.style.opacity = '';
      ring.style.opacity = '';
    });
  }


  // ======== Popup modale : Promo Fête des Mères ========
  // Apparaît 5s après chaque chargement de page.
  const modal = document.getElementById('promoModal');
  const modalClose = document.getElementById('promoModalClose');
  const modalOverlay = document.getElementById('promoModalOverlay');
  const modalDismiss = document.getElementById('promoModalDismiss');

  if (modal) {
    function showModal() {
      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function hideModal() {
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Affichage à chaque chargement
    setTimeout(showModal, 5000);

    if (modalClose) modalClose.addEventListener('click', hideModal);
    if (modalDismiss) modalDismiss.addEventListener('click', hideModal);
    if (modalOverlay) modalOverlay.addEventListener('click', hideModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-visible')) {
        hideModal();
      }
    });

    const modalCta = modal.querySelector('.promo-modal__cta');
    if (modalCta) {
      modalCta.addEventListener('click', () => {
        setTimeout(hideModal, 300);
      });
    }
  }
})();
